export default{
    //更新前瞻
    Update:{
        updateoup:'Update Outlook',
        newNotice:'New Notice',
        xinxi1:'The new version of "Tower Defense Game" in 2025, "Crazy Night", is about to be launched. With brand new maps, heroes, and gameplay, you are waiting to battle!',
        xinxi2:'Tower Defense Game Update Announcement on January 2, 2025',
        xinxi3:'Tower Defense Game Update Announcement on December 18, 2024',
        xinxi4:'Tower Defense Game: Outlaws of the Realm - The Great Sword',
        xinxi5:'Tower Defense Game Update Announcement on November 30, 2024'
        
    },
    //特色
    feature:{
        tilteName:'Feature'
    },
    //底部
    foorter:{
        YHZX:'User Center',
        KFZX:'Customer Service Center',
        FWTK:'Term of service',
        YSZC:'Privacy Policy',
        GYWM:'About Us',
        ZX:'Account deletion',
        p1:'The copyright of the images on this website belongs to our company and may not be reproduced without permission',
        p2:'Game Health Announcement: Boycott Bad Games, Reject Pirated Games, Pay Attention to Self Protection, Beware of Being Scammed, Moderate Gaming Benefits Brain Addiction, Harm Body, Reasonably Arrange Time, Enjoy a Healthy Life',
        p3:'Illegal and harmful information reporting hotline: 4009936669',
        p4:'Report and contact email for online games by the Ministry of Culture: wlyxjb@gmail.com',
        gsmc:'corporate name：Sichuan Vitality Sugar Technology Co., Ltd',
        gsdz:'Address： No. 399 Fucheng Avenue West, Chengdu High tech Zone, China (Sichuan) Pilot Free Trade Zone , Tianfu New Valley Building 7, Block C, 6th Floor  Chengdu',
    },
    //注销
    zhuxiao:{
        daTs:'Account Cancellation Notice',
        yedu:'Please carefully read the following notices and complete identity verification',
        fxTs:'Cancellation Risk Warning',
        title:'Account Cancellation',
        ts1:'After account cancellation, all game data (characters, items, recharge records, etc.) will be permanently deleted and cannot be recovered.',
        ts2:'After cancellation, this account will not be able to log in to all associated game products.',
        ts3:'If there are unspent virtual currency or undated membership services in the account, no refund will be given after cancellation.',
        ts4:'After the cancellation operation is submitted, the system will complete the processing within 24 hours, during which the account will be temporarily frozen.',
        chhu:'title',
        zhID:'ID',
        email:'Email',
        chhuTs:'Please enter your title',
        zhIDTs:'Please enter your ID',
        emailTs:'Please enter your email (optional)',
        anNiu:'Confirm Account Cancellation',
        fhTs:'Return and redo the operation',
        tjcg:'Cancellation application submitted successfully',

        quren:'Final Confirmation',
        zxtsEr:'Are you sure you want to cancel this game account?',
        qurenTs:'All data will be permanently deleted after cancellation and cannot be recovered!',
        qrtx:'Please enter "Confirm Cancellation" to confirm your account cancellation request',
        tjAn:'Submit Cancellation',
        quxiao:'Cancel',
        
        // 注销提示
        ch_message:'Please enter your title',
        id_message:'Please enter your ID',
        email_message:'Please enter a valid email address',
        confirm_message:'Please enter the correct confirmation text',
        
        Gui_ch:'Title length is 3-30 characters',
        Gui_id:'ID length is 6-20 characters',
    }
}